__turbopack_context__.v({
  "loadMoreSentinel": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__loadMoreSentinel",
  "main": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__main",
  "monthSelector": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__monthSelector",
  "secondaryCtaWrapper": "FeatureAnnouncementContainer-module-scss-module__Wl75lG__secondaryCtaWrapper",
});
